import { Link } from "react-router-dom";
import { LegalLayout, IssuerBlock, ProductOwnerNote, LiabilityText, useLegalInfo } from "@/components/LegalLayout";

const L = ({ to, children }) => <Link to={to} className="font-semibold text-petrol underline">{children}</Link>;

export default function Terms() {
  const info = useLegalInfo();
  return (
    <LegalLayout title="Termos de Utilização" testid="terms-page">
      <ProductOwnerNote info={info} />
      <p>Estes termos regulam a utilização da plataforma GestaCV e a subscrição dos seus planos. Ao criar uma conta ou pagar um plano, a empresa aceita estes termos.</p>
      <h2>1. Serviço</h2>
      <p>O GestaCV é uma plataforma online de gestão para pequenas e médias empresas (clientes, orçamentos, vendas, caixa, despesas, relatórios, site público e outros módulos). Cada empresa acede apenas aos seus próprios dados.</p>
      <h2>2. Conta e acesso</h2>
      <p>A empresa é responsável pelos utilizadores que convida, pela veracidade dos dados introduzidos e por manter as palavras-passe em segurança. Deve avisar-nos de imediato se suspeitar de acesso não autorizado.</p>
      <h2>3. Teste grátis e planos</h2>
      <p>Após o registo há um teste grátis de 30 dias, sem cartão. Depois, a empresa escolhe um plano pago (mensal, 6 meses ou 12 meses) aos preços publicados na página de planos, em escudos cabo-verdianos (CVE).</p>
      <h2>4. Pagamento</h2>
      <ul>
        <li>Cartões emitidos em Cabo Verde: Cartão Vinti4 / Visa / Mastercard / Amex, através da página segura da SISP, em CVE.</li>
        <li>Cartões estrangeiros: cartão internacional processado pela Stripe, cobrado em EUR ao câmbio indicado.</li>
        <li>Transferência bancária, com referência única.</li>
      </ul>
      <p>Após cada pagamento confirmado é emitido um Recibo com a referência de pagamento, enviado por email. O preço é o mesmo em todos os meios de pagamento (Vinti4, cartão internacional ou transferência), sem taxas extra por pagar com cartão.</p>
      <h2>5. Entrega do serviço</h2>
      <p>O GestaCV é um serviço digital. O acesso ao plano pago é ativado logo após a confirmação do pagamento, na conta da empresa. Não há envio físico de bens nem custos de entrega.</p>
      <h2>6. Renovação e cancelamento</h2>
      <p>Os pagamentos por Vinti4 e transferência cobrem o período escolhido e não renovam automaticamente; avisamos por email 7 dias e 1 dia antes do fim. A subscrição por cartão internacional (Stripe) renova automaticamente até ser cancelada no painel. Em qualquer caso, o cancelamento produz efeito no fim do período já pago.</p>
      <h2>7. Devoluções</h2>
      <p>As devoluções e cancelamentos seguem a <L to="/politica-de-devolucao">Política de Devolução e Cancelamento</L>.</p>
      <h2>8. Utilização aceitável</h2>
      <p>Não é permitido usar a plataforma para atividades ilegais, enviar conteúdos ofensivos ou de terceiros sem autorização, nem tentar aceder a dados de outras empresas ou perturbar o funcionamento do serviço. O incumprimento pode levar à suspensão da conta.</p>
      <h2>9. Dados</h2>
      <p>Os dados introduzidos pela empresa pertencem à empresa. O tratamento de dados pessoais segue a <L to="/privacidade">Política de Privacidade</L>.</p>
      <h2>10. Disponibilidade</h2>
      <p>Esforçamo-nos por manter o serviço disponível e seguro, mas podem existir interrupções para manutenção ou por causas externas.</p>
      <h2>11. Limitação de responsabilidade</h2>
      <LiabilityText info={info} />
      <h2>12. Alterações</h2>
      <p>Podemos atualizar estes termos. A data da última atualização está no topo desta página; alterações importantes são comunicadas por email.</p>
      <h2>13. Lei aplicável</h2>
      <p>Estes termos regem-se pela lei de Cabo Verde.</p>
      <h2>14. Contacto</h2>
      <IssuerBlock info={info} />
    </LegalLayout>
  );
}
